import Controller from '@ember/controller';

import { EmailConfirmationRoute } from 'register-partners-js/react/routes/welcome/email-confirmation';

export default class WelcomeEmailConfirmationController extends Controller {
  emailConfirmationRoute = EmailConfirmationRoute;
}
